import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { DocumentMetaSelector } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-seo-tag-container",
	templateUrl: "./seo-tag.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SeoTagContainer implements OnInit {
	@HostBinding("class.obg-seo-tag") hostCssClass = true;

	@Input() content: string | undefined;

	h1TitleExists$: Observable<boolean> | undefined;

	@Input() set disableHeaderTag(value: boolean) {
		this._disableHeaderTag = coerceBooleanProperty(value);
	}

	get disableHeaderTag() {
		return this._disableHeaderTag;
	}

	private _disableHeaderTag = false;

	constructor(private store: Store<CoreContentState>) {}

	ngOnInit() {
		this.h1TitleExists$ = this.store
			.select(DocumentMetaSelector.getSeoContent)
			.pipe(map((page) => !!page?.h1Title));
	}
}
